module.exports = __webpack_public_path__ + "img/polaris.b919a61b.png";